"use client";

import type React from "react";
import { useEffect, useState } from "react";
import { Plus } from "lucide-react";
import useApiHook from "../../../../utils/useApi";
import type { PermApiResponse } from "../../../../interface/interfaces";
import CustomRoleModal from "../../../../components/modals/CustomRoleModal";

const AddCustomRoleButton: React.FC = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [permissions, setPermissions] = useState<string[]>([]);

  const { data, isLoading, makeRequest } = useApiHook<PermApiResponse>(
    "/admin/system-role",
    {
      method: "get",
    }
  );

  useEffect(() => {
    makeRequest();
  }, []);

  useEffect(() => {
    if (data && data.data && data.data.rolePermissions) {
      setPermissions(data.data.rolePermissions);
    }
  }, [data]);

  const handleAddCustomRole = () => {
    setIsModalOpen(true);
  };

  return (
    <>
      <button
        className="w-full flex items-center justify-center gap-2 py-2 px-4 text-sm text-gray-600 bg-gray-50 hover:bg-gray-100 rounded border border-gray-200 transition-colors"
        onClick={handleAddCustomRole}
      >
        <Plus size={16} />
        <span>Add Custom Role</span>
      </button>

      <CustomRoleModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        permissions={permissions}
      />
    </>
  );
};

export default AddCustomRoleButton;
